module.exports = __webpack_public_path__ + "img/email.0339a67f.png";